import {nominate} from "../../Types";
import {mutate, useMutationDone} from "../../state";
import externalApi from "../../api/external";
import {takeUrlParameter} from "../../utils/urlParams";

{
  const accessToken = takeUrlParameter("access_token");
  if (accessToken) {
    const clientAccountId = nominate("accountId", takeUrlParameter("client_account_id")!);

    // Attempt to login with the access token
    mutate({
      mutationKey: ["external", "login"],
      mutationFn: async () => {
        const clientAccount = await externalApi.accounts.get(clientAccountId);
        await externalApi.auth.login(clientAccount, accessToken);
      },
    });
  }
}

// It's important that this is in the same file as the above code so that the side effect runs
// on any pages where this hook is used.
export function useExternalLoginDone() {
  return useMutationDone({mutationKey: ["external", "login"]});
}
